import { isRbiOrderValid } from 'experiments/checkout-v2/control/pages/cart/payment/order-payment/util';
import { useCartContext } from 'state/cart';

export function useOrderIsValidCheck(): boolean {
  const { rbiOrderId } = useCartContext();
  return isRbiOrderValid(rbiOrderId);
}
